<template>
  <div class="c-input-checkbox__wrap">
    <label
      class="c-input-checkbox__label"
      :class="[
        `-${kind}`,
        {
          '-checked': ischecked,
          '-disabled': disabled
        }
      ]"
    >
      <div class="c-input-checkbox__icon__wrap">
        <input
          type="checkbox"
          :name="name"
          :value="value"
          :checked="checked === value"
          class="c-input-checkbox"
          :class="{
            'c-input-radio--error': error
          }"
          :error="error"
          :disabled="disabled"
          @change="updateValue"
        />
        <IconBase
          v-show="value"
          view-box="0 0 18 18"
          width="18"
          height="18"
          class="c-input-checkbox__icon"
        >
          <IconCheckbox />
        </IconBase>
      </div>
      <span
        class="c-input-checkbox__text"
        :class="{ 'c-input-checkbox__text--checked': checked === value }"
      >
        <slot></slot>
      </span>
    </label>
  </div>
</template>

<script lang="ts">
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconCheckbox from "@/common/components/icons/IconCheckbox.vue";
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    name: { type: String, required: true },
    kind: { type: String, required: false, default: "main" },
    error: { type: String, required: false },
    disabled: { type: Boolean, default: false },
    checked: { type: [String, Boolean], required: true },
    value: { type: [String, Boolean], required: true }
  },
  components: {
    IconBase,
    IconCheckbox
  }
})
export default class InputCheckBox extends Vue {
  name!: string;
  checked!: any;
  value!: any;
  kind!: string;
  error!: string;
  disabled!: boolean;

  updateValue(e: Event) {
    const target = e.target as HTMLInputElement;
    const value = target.checked ? this.value : "";
    this.$emit("update:checked", value);
    this.$emit("checked", value);
  }

  get ischecked() {
    return this.checked === this.value;
  }
}
</script>

<style lang="scss" scoped>
.c-input-checkbox {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;

  &__icon {
    color: $common-white;
    position: absolute;
    left: 0;
    top: 0;

    &__wrap {
      position: relative;
      width: rem(18);
      min-width: rem(18);
      height: rem(18);
      border: px(1) solid $common-gray-border;
      background-color: $common-white;
      border-radius: px(3);
      display: block;
    }
  }

  &__wrap {
    display: inline-block;
  }

  &__label {
    padding: rem(12) rem(16) rem(12) rem(4);
    display: flex;
    align-items: center;
    cursor: pointer;

    &.-disabled {
      opacity: 0.3;
      cursor: default;
    }
  }

  &__label.-checked &__icon__wrap {
    border: none;
  }

  &__label.-checked.-main &__icon__wrap {
    background-color: $common-black;
  }
  &__label.-checked.-secondary &__icon__wrap {
    background-color: $common-gray700;
  }

  &__text {
    font-size: rem(14);
    line-height: (24/14);
    margin-left: rem(8);
  }
}
</style>
